import _this from '../main'
// 设置 rem 函数
function setRem () {
  let htmlWidth = document.documentElement.clientWidth || document.body.clientWidth;
  let htmlDom = document.getElementsByTagName('html')[0];
  let bodyDom = document.getElementsByTagName('body')[0]

  let scale = 1.7 // 三星手机的倍数
  let small_page = _this.$utils.compatibleMobilePage
  let small_scale_html = small_page.includes(_this.$route.name) ? (14.4 / scale) : 14.4
  let small_scale_body = small_page.includes(_this.$route.name) ? `${12 * scale}px` :'12px'

  htmlDom.style.fontSize = htmlWidth <= 1440 ?
    (htmlWidth <= 991 ?
      ((htmlWidth / small_scale_html) + 'px')
      : htmlWidth/14.4 + 'px')
    : 1440/14.4 + 'px';
  bodyDom.style.fontSize = htmlWidth <= 1440 ?
    (htmlWidth <= 991 ?
      small_scale_body
      : '12px')
    : '16px'

  if (!htmlDom.style.fontSize || htmlDom.style.fontSize === '') {
    console.log(htmlWidth, htmlDom.style.fontSize, bodyDom)
    setRem()
  }
}

// 初始化
setTimeout(()=> {
  setRem()
}, 50)

window.addEventListener('resize', () => {
  setRem()
}, false)



// WEBPACK FOOTER //
// ./src/global/rem.js